(function () {
  'use strict';
  function addBusinessDays(dateKey, days) {
    const date = new Date(dateKey + 'T12:00:00Z');
    while (days > 0) { date.setUTCDate(date.getUTCDate() + 1); if (![0, 6].includes(date.getUTCDay())) days--; }
    return date.toISOString().slice(0, 10);
  }
  function preparationDays(orderDate) {
    return [0, 3, 4, 5, 6].includes(new Date(orderDate + 'T12:00:00Z').getUTCDay()) ? 2 : 3;
  }
  function timeline(orderDate) {
    const ready = addBusinessDays(orderDate, preparationDays(orderDate));
    return { ordered: orderDate, ready, earliest: addBusinessDays(ready, 1), latest: addBusinessDays(ready, 5) };
  }
  if (typeof module !== 'undefined') module.exports = { addBusinessDays, preparationDays, timeline };
  if (typeof document === 'undefined') return;
  const script = document.currentScript;
  const zone = script?.dataset.shopTimeZone || 'America/Los_Angeles';
  const format = key => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(new Date(key + 'T12:00:00Z'));
  const today = () => {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: zone }).formatToParts(new Date()).map(x => [x.type, x.value]));
    return `${p.year}-${p.month}-${p.day}`;
  };
  function update() {
    const root = document.querySelector('[data-catalog-layout]'); if (!root) return;
    const dates = timeline(today());
    const set = (selector, text, tooltip) => {
      const el = root.querySelector('[data-bold-delivery] ' + selector + ' .date__sub-content > span'); if (!el) return;
      const node = [...el.childNodes].find(n => n.nodeType === 3);
      if (node && node.textContent !== text) node.textContent = text;
      const p = el.querySelector('p'); if (p && p.textContent !== tooltip) p.textContent = tooltip;
    };
    const days = preparationDays(dates.ordered);
    set('.ordered-content-box__step-box', format(dates.ordered), 'Allow ' + days + ' business days after placing your order for shipment preparation.');
    set('.order-ready-content-box__step-box', format(dates.ready), 'Estimated ready to ship ' + days + ' business days after your order is placed.');
    set('.order-delivered-content-box__step-box', format(dates.earliest) + ' – ' + format(dates.latest), 'Estimated delivery 1–5 business days after your order is ready; timing depends on the shipping method chosen at checkout.');
    const input = root.querySelector('input[name="properties[Delivery Estimated between (depending on your selected shipping speed)]"]');
    if (input) input.value = format(dates.earliest) + ' and ' + format(dates.latest);
    root.dataset.draftOrderReady = dates.ready; root.dataset.draftDeliveryEarliest = dates.earliest; root.dataset.draftDeliveryLatest = dates.latest;
  }
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); };
  const init = () => { update(); const root = document.querySelector('[data-catalog-layout]'); if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('product-info:loaded', schedule);
  setInterval(schedule, 60000);
})();
